import { BrandingCustomCssToolResult } from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.models'
import { ToolHandler, ToolApplyContext } from '../tool-handler.interface'
import { ToolConfig, SetupGuideAiMessage } from '../../types/ai-chat.types'

export class CustomCssHandler implements ToolHandler {
  name = 'generate_custom_css'
  config: ToolConfig = {
    labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_CUSTOM_CSS.LABEL',
    generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_CUSTOM_CSS.GENERATING',
    resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_CUSTOM_CSS.RESULT',
    displayType: 'css',
    dashboardPage: 'branding',
  }

  getPreviewData(message: SetupGuideAiMessage): string {
    if (!message.toolContent) {
      return ''
    }

    const customCss = (message.toolContent as BrandingCustomCssToolResult).custom_css
    return customCss.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n')
  }

  canApply(message: SetupGuideAiMessage): boolean {
    return !!message.toolContent
  }

  apply(message: SetupGuideAiMessage, context: ToolApplyContext): void {
    if (!message.toolContent) {
      return
    }

    const customCss = message.toolContent as BrandingCustomCssToolResult
    context.gbSetupGuideProgressService.appendCustomCss(customCss.custom_css)
  }
}
